import script from "./EditInvoice.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditInvoice.vue?vue&type=script&lang=ts&setup=true"

import "./EditInvoice.vue?vue&type=style&index=0&id=492cbfe3&lang=scss&scoped=true"

import exportComponent from "/home/forge/saf.groupebiou.bj/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-492cbfe3"]])

export default __exports__